import React from "react";

const MapSection: React.FC = () => {
  return (
    <section className="elementor-section elementor-top-section elementor-element elementor-element-b35b84a elementor-section-full_width elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
      <div className="elementor-container elementor-column-gap-no">
        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d92b45a sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-0a4c225 sc_fly_static elementor-widget elementor-widget-trx_sc_googlemap trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div id="sc_googlemap_1686189284_wrap" className="sc_googlemap_wrap ready">
                  <div id="sc_googlemap_1686189284" className="sc_item_content sc_map sc_googlemap sc_googlemap_default trx_addons_inline_672596778 inited" 
                       data-zoom="12" 
                       data-center="51.499,-0.13" 
                       data-style="extra" 
                       data-map-id="" 
                       data-cluster-icon="" 
                       style={{position: "relative", overflow: "hidden"}}>
                    
                    {/* Google Maps iframe */}
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5543.2832008550895!2d80.15775783671417!3d12.911558243952374!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525ee602bff21d%3A0x8092acf620c1fe00!2sJothi%20Software%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1712235819368!5m2!1sen!2sin"
                      width="100%"
                      height="500"
                      style={{border: 0, position: "relative", zIndex: 1}}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Google Maps - Contact Location"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
